import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { APP_URLS, getAppUrl } from 'utils/app-urls';

import { Icon } from '@asgard/ui-library';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import * as S from './PostCard.styled';
import { WP_REST_API_Post } from 'wp-types';
import { useEffect } from 'react';

export type PostCardProps = {
  post: WP_REST_API_Post;
  url: string;
  title: string;
  thumb?: string;
  isFeatured?: boolean;
  date: string;
  excerpt?: string;
};

const PostCard: React.FC<PostCardProps> = ({
  post,
  url,
  title,
  thumb,
  date,
  excerpt = '',
  isFeatured = false
}) => {
  const { locale } = useRouter();

  useEffect(() => {
    console.log({ excerpt });
  });

  return (
    <Link
      href={`${getAppUrl(APP_URLS.successStories, locale)}/${url}`}
      passHref
    >
      <S.Card $isFeatured={isFeatured}>
        <svg width="0" height="0">
          <defs>
            <clipPath id="blogThumbClip" clipPathUnits="objectBoundingBox">
              <path d="..." />
            </clipPath>
          </defs>
        </svg>
        <S.Thumb $isFeatured={isFeatured}>
          {thumb && <img src={thumb} alt="" />}
        </S.Thumb>

        <S.CardContent>
          <S.Date>
            <Icon icon={faCalendar} />
            {new Date(date).toLocaleDateString(locale, {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            })}
          </S.Date>
          <S.Title $isFeatured={isFeatured}>{title}</S.Title>
          <S.Excerpt>
            <div
              dangerouslySetInnerHTML={{
                __html: excerpt
              }}
            ></div>
          </S.Excerpt>
        </S.CardContent>
      </S.Card>
    </Link>
  );
};

export default PostCard;
